var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CTA } from '../call-to-action';
export const CardFooter = ({ children, footerLinks, }) => {
    return (React.createElement(React.Fragment, null,
        React.Children.toArray(footerLinks.map((_a) => {
            var { text } = _a, rest = __rest(_a, ["text"]);
            return (React.createElement(CTA, Object.assign({ key: text }, rest), text));
        })),
        children));
};
